import React from 'react'
import {ProductImageCarousel} from '../product'
import {Dialog, DialogContent, DialogTitle} from '@/components/ui/dialog'
import {ProductDetail} from '../product'
import {useProductContext} from '@/context/ProductContext'
import useMediaQuery from 'hec/hooks/useMediaQuery'

interface ProductQuickviewModalProps {
    setShowQuickview?: React.Dispatch<React.SetStateAction<boolean>>
}

export const ProductQuickviewModal: React.FC<ProductQuickviewModalProps> = ({setShowQuickview}) => {
    const {setQuickviewModalOpen, quickviewModalOpen} = useProductContext()
    const isMobile = useMediaQuery('sm')
    return (
        <Dialog
            open={quickviewModalOpen ?? false}
            onOpenChange={(isOpen) => {
                setQuickviewModalOpen(isOpen)
                if (setShowQuickview) {
                    setShowQuickview(false)
                }
            }}
            data-testid="productQuickviewModal-Dialog"
        >
            <DialogContent
                className={`pt-9 px-10 max-w-none flex flex-col max-h-[90vh] overflow-y-auto ${
                    isMobile ? 'w-[90%]' : 'w-[50%]'
                }`}
                data-testid="productQuickviewModal-DialogContent"
            >
                <DialogTitle className="sr-only">Product Quick View</DialogTitle>
                <div className="flex lg:flex-row flex-col lg:space-x-8 space-x-4 items-start">
                    <div className="relative lg:w-1/2 flex justify-center items-center">
                        <ProductImageCarousel data-testid="productQuickviewModal-ProductImageCarousel" />
                    </div>
                    <ProductDetail
                        className="lg:w-1/2 lg:mt-0 mt-[3rem]"
                        data-testid="productQuickviewModal-ProductDetail"
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}
